import { Component, Inject, LOCALE_ID, ViewChild } from '@angular/core';
import { BasePageComponent } from 'src/app/components/base-page/base-page.component';
import { environment } from 'src/environments/environment';
import { TranslationConfig } from 'src/app/utils/translate-config';
import { promotionsTrx } from 'src/app/router-translation.labels';
import { SwiperOptions } from 'swiper';
import { SwiperComponent } from 'swiper/angular';
import { DesktopService } from 'src/app/services/desktop/desktop.service';
import { CardWidgetPageResponse, ExpansionPanelItem } from 'src/app/apollo/models/base-models';

@Component({
  selector: 'app-home-page-promotions',
  templateUrl: './home-page-promotions.component.html',
  styleUrls: ['./home-page-promotions.component.scss']
})
export class HomePagePromotionsComponent extends BasePageComponent {

  constructor(
    protected translationConfig: TranslationConfig,
    @Inject(LOCALE_ID) public locale: string,
    private desktopService: DesktopService,
  ) { super() }
  // @ViewChild('swiper', { static: false }) swiper?: SwiperComponent;
  @ViewChild(SwiperComponent, { static: false }) componentRef?: SwiperComponent;
  config: SwiperOptions = {
    direction: 'horizontal',
    slideToClickedSlide: false,
    mousewheel: false,
    scrollbar: false,
    // navigation: <SwiperNavigationInterface>{
    //   nextEl: '.button-next',
    //   prevEl: '.button-prev'
    // },
    keyboard: true,
    freeMode: false,
    slidesPerView: 3,
    slidesPerGroup: 1,
    centerInsufficientSlides: false,
    centeredSlides: false,
    loop: false,
    spaceBetween: 8,
    pagination: false,
    observer: true,
    observeParents: true,
    parallax: true,
  };

  enableTournamentsDisplay = environment.enableTournamentsDisplay;
  startDate = new Date(new Date().getTime() + (2 * 60 * 60 * 1000));
  numberTournaments = 0;
  public promotionsTrx = this.translationConfig.getTranslation(promotionsTrx)
  promotionsData: any;
  expansionPanel: ExpansionPanelItem[]

  public static filterPromoPagebyCountry(promoData: CardWidgetPageResponse, country: string) {
    return promoData.cardWidgetPages.find((page) => {
      return page.country?.includes(country);
    }) || promoData.cardWidgetPages[0];
  }

  ngOnInit(): void {
    this.desktopService.staticPromotionData('promotions-front').subscribe((res:any) => {
      const promoPage = HomePagePromotionsComponent.filterPromoPagebyCountry(res, this.locale)
      const cardWidgetElements = promoPage.cardWidgetElements as unknown as any[];
      this.promotionsData = cardWidgetElements;
    })
  }

  next() {
    this.componentRef.swiperRef.slideNext();
  }

  prev() {
    this.componentRef.swiperRef.slidePrev();
  }

}
